export const USER_FROM_USER = 'User';
export const USER_FROM_VENDOR = 'Vendor';
